import { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';

const links: { label: string; to: string }[] = [
  { label: 'Home', to: '/home' },
  { label: 'Facilities', to: '/facilities' },
  { label: 'Activities', to: '/activities and attractions' },
  { label: 'Calendar', to: '/calendar' },
  { label: 'News', to: '/news' },
  { label: 'Contact', to: '/contact' },
];

const Navigation = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="nav">
      <div className="container nav-inner">
        <Link to="/home" className="brand" onClick={() => setOpen(false)}>
          <b>Upward Bound</b>
          <span>Retreat &amp; Camp</span>
        </Link>

        <button
          className="nav-toggle"
          aria-label="Toggle menu"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            {open
              ? <><line x1="6" y1="6" x2="18" y2="18" /><line x1="18" y1="6" x2="6" y2="18" /></>
              : <><line x1="3" y1="7" x2="21" y2="7" /><line x1="3" y1="12" x2="21" y2="12" /><line x1="3" y1="17" x2="21" y2="17" /></>}
          </svg>
        </button>

        <nav>
          <ul className={`nav-links ${open ? 'open' : ''}`}>
            {links.map((l) => (
              <li key={l.to}>
                <NavLink
                  to={l.to}
                  className={({ isActive }) => (isActive ? 'active' : '')}
                  onClick={() => setOpen(false)}
                >
                  {l.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Navigation;
